import React from "react";

import { usePageDetails } from "../../hooks/usePageDetails";
import "./create-heading.scss";

const CreateHeading = ({ label }: { label: string }) => {
  const { pageType } = usePageDetails();

  const updatedLabel =
    pageType === "create"
      ? `Create ${label}`
      : pageType === "edit"
        ? `Edit ${label} Details`
        : `View ${label} Details`;
  return <h4 className="create-heading">{updatedLabel}</h4>;
};

export default CreateHeading;
